import React, { useMemo } from 'react';
import { Wrapper } from 'app/components/district/common/ActivityStyles';
import TransferActivityHeader from 'app/components/district/transfers/TransferActivityHeader';
import { captureSentryException } from 'app/services/sentry/sentryLogging';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { LinkOnComponent } from 'app/components/links/link';
import VisualTransfer from 'app/components/district/transfers/VisualTransfer';
import TransferDescription from 'app/components/district/transfers/TransferDescription';
const Content = styled.div.withConfig({
  componentId: "sc-uibdjq-0"
})(["display:flex;flex-direction:column;align-items:center;padding:", ";"], SIZES[16]);
const PlayerName = styled(Typography).withConfig({
  componentId: "sc-uibdjq-1"
})(["&&&{color:", ";}"], COLORS.darkestGrey);
export default function TransferActivity(_ref) {
  let {
    data
  } = _ref;
  const relevantTeamName = useMemo(() => {
    var _data$fromTeam;
    const relevantTeam = (_data$fromTeam = data.fromTeam) !== null && _data$fromTeam !== void 0 ? _data$fromTeam : data.toTeam;
    if (!relevantTeam) {
      captureSentryException(new Error("No linked team found for transfer ".concat(data.getKey())));
      return 'Unbekannt';
    }
    return relevantTeam.getName();
  }, [data]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TransferActivity",
    "data-sentry-source-file": "TransferActivity.tsx"
  }, /*#__PURE__*/React.createElement(TransferActivityHeader, {
    teamName: relevantTeamName,
    publishDate: data.formatReportDate(),
    "data-sentry-element": "TransferActivityHeader",
    "data-sentry-source-file": "TransferActivity.tsx"
  }), /*#__PURE__*/React.createElement(Content, {
    "data-sentry-element": "Content",
    "data-sentry-source-file": "TransferActivity.tsx"
  }, /*#__PURE__*/React.createElement(VisualTransfer, {
    data: data,
    "data-sentry-element": "VisualTransfer",
    "data-sentry-source-file": "TransferActivity.tsx"
  }), /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.getLink(),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "TransferActivity.tsx"
  }, /*#__PURE__*/React.createElement(PlayerName, {
    variant: "subheading",
    "data-sentry-element": "PlayerName",
    "data-sentry-source-file": "TransferActivity.tsx"
  }, data.getPlayerName())), /*#__PURE__*/React.createElement(TransferDescription, {
    data: data,
    "data-sentry-element": "TransferDescription",
    "data-sentry-source-file": "TransferActivity.tsx"
  }), data.note ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1"
  }, data.note) : null));
}